import { styled } from "@mui/material/styles";
import { Typography, Button, Grid } from "@mui/material";

export const DivCoverReturn = styled("div")(({ theme }) => ({
  width: "100%",
  marginTop: "20px",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "10px",
}));

export const DivContent = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: "1100px",
  padding: "10px",
  marginBottom: "50px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}));

export const DivTopic = styled(Grid)(({ theme }) => ({
  display: "flex",
  border: "1px solid #bdbdbd",
  borderRadius: "8px",
  padding: "10px 20px 10px 20px",
  flexDirection: "column",
  gap: "10px",
}));

export const TextMainTopic = styled(Typography)(({ theme }) => ({
  fontSize: "20px",
  fontWeight: 600,
  marginBottom: "5px",
  color: theme.palette.text.primary,
}));

export const TextTopic = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 500,
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const TextData = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 300,
  color: theme.palette.text.secondary,
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const StatusData = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  marginLeft: "10px",
  fontWeight: "600",
  color: "#919eab",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const DivTopicAndData = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  width: "100%",
  gap: "10px",
}));

export const LinkStyled = styled("a")(({ theme }) => ({
  width: "30%",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

export const ViewButton = styled(Button)(({ theme }) => ({
  border: "1.75px solid #00bb77",
  borderRadius: "5px",
  color: "black",
  width: "100%",
  padding: "10px",
  fontWeight: "bolder",
  fontSize: "20px",
  backgroundColor: theme.palette.primary.main,
  color: "white",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
    color: "white",
  },
}));
